/* eslint-disable @typescript-eslint/no-unused-vars */
import { PageType, ProductCardType } from '@/constants'
import { useStore } from '@/containers'

interface SalePriceType {
  type?: string
  classes?: string
  finalPrice: number
  finalPriceText?: string
}

export const SalePrice = ({
  finalPrice,
  classes,
  type,
  finalPriceText,
}: SalePriceType) => {
  const { selectedLang } = useStore()
  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'USD'
      default:
        return 'VND'
    }
  }

  const formattedPrice = (priceStr: string) => {
    const rawNumber = parseInt(priceStr.replace(/[.,đ\s]/g, ''))

    const millions = Math.floor(rawNumber / 1000000)
    const thousands = Math.floor((rawNumber % 1000000) / 1000)
    if (millions >= 100) {
      return `${millions}.xxx.000đ`
    } else if (millions >= 10) {
      return `${millions}.xxx.000đ`
    } else if (millions >= 1) {
      return `${millions}.xxx.000đ`
    } else if (thousands >= 100) {
      return `xxx.000đ`
    } else if (thousands >= 10) {
      return `xx.000đ`
    } else if (thousands >= 1) {
      return `x.000đ`
    } else {
      return `0đ`
    }
  }

  const priceString = finalPrice
    ? finalPrice
        .toLocaleString(selectedLang as string, {
          style: 'currency',
          currency: currency('USD'),
        })
        .replace(/\s₫/g, 'đ')
    : '0đ'

  return (
    <p
      className={`${classes ? classes : ''}  ${
        type == PageType.PRODUCT
          ? 'text-orange'
          : 'text-redPico text-[16px] leading-none font-bold'
      }  `}
    >
      {type === ProductCardType.FLASH_SALE_TIME ? finalPriceText : priceString}
    </p>
  )
}

export default SalePrice
